module.exports = __webpack_public_path__ + "img/logo_black.0ae95f31.svg";